import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { itemGroupSchema, type ItemGroupFormValues } from '../schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { Group } from '@/types/schemas';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ItemGroupFormValues) => void | Promise<void>;
  formMode: 'add' | 'edit' | 'view';
  initialData?: Group;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  const formInitialData: ItemGroupFormValues | undefined = initialData
    ? {
        ma_nhom: formMode === 'add' ? '' : initialData.ma_nhom,
        ten_phan_nhom: initialData.ten_phan_nhom,
        ten2: initialData.ten2 || '',
        trang_thai: initialData.trang_thai || '1'
      }
    : undefined;

  const handleSubmit = async (data: ItemGroupFormValues) => {
    try {
      await onSubmit(data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={`${formMode === 'add' ? 'Thêm mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục phân nhóm'}`}
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={281} />}
      paperClassName='w-[min(760px,calc(100vw-16px))]'
    >
      <AritoFormV2
        mode={formMode}
        hasAritoActionBar={false}
        schema={itemGroupSchema}
        onSubmit={handleSubmit}
        initialData={formInitialData}
        className='w-full min-w-0 max-w-full'
        headerFields={<BasicInfoTab formMode={formMode} />}
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onClose={onClose}
            submitTitle='Đồng ý'
          />
        }
      />
    </DialogV2>
  );
};

export default FormDialog;
